import React from 'react';
import styled, { css } from 'styled-components/macro';

type TimePickerWrapperProps = {
  disabled: boolean;
};

const TimePickerWrapper = styled.div<TimePickerWrapperProps>`
  margin-top: 16px;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}
`;

type TimeProps = {
  selected?: boolean;
};
const Time = styled.div<TimeProps>`
  color: ${props => props.theme.colors.neutral[80]};
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  background: ${props => props.theme.colors.neutral[10]};
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  border-radius: 5px;
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 8px;
  ${({ selected, theme }) =>
    selected &&
    css`
      border: 1px solid ${theme.colors.secondary[100]};
    `}
  >span {
    position: relative;
    ${({ selected, theme }) =>
      selected &&
      css`
    &:before{
      content: '';
      position: absolute;
      left: -65px;
      top: 2px;
      display: selected ? inline-block : none;
      transform: rotate(45deg);
      height: 13px;
      width: 6px;
      margin-left: 60%;
      border-bottom: 2px solid ${theme.colors.secondary[100]};
      border-right: 2px solid ${theme.colors.secondary[100]};
    }
  `}
  }
`;

type Props = {
  disabled: boolean;
  time: number | undefined;
  onChangeTime: (time: number) => void;
};
const addZeros = (value: number) => {
  const pad = '00';
  return (
    '00'.substring(0, pad.length - value.toString().length) + value + ':00'
  );
};
const getTimeOptions = (min: number, max: number) => {
  let i = 0;
  let options = [];
  for (let j = min; j <= max; j++) {
    i = j == 0 ? 12 : j > 12 ? j - 12 : j;
    const ampm = j < 12 ? ' am' : ' pm';
    options.push({ value: j, label: addZeros(i) + ampm });
  }
  return options;
};

export const TimePicker = ({ disabled, time, onChangeTime }: Props) => {
  const options = getTimeOptions(9, 17);
  return (
    <TimePickerWrapper disabled={disabled}>
      {options.map((option, i) => (
        <Time
          key={i}
          selected={option.value === time}
          onClick={() => onChangeTime(option.value)}
        >
          <span>{option.label}</span>
        </Time>
      ))}
    </TimePickerWrapper>
  );
};
